// Google Calendar API 服务
// 用于同步教练课程安排

/**
 * 获取教练的每日课程安排
 * @param {string} instructorId - 教练ID
 * @param {Date} date - 查询日期
 * @returns {Promise<Array>} 课程列表
 */
export const getInstructorSchedule = async (instructorId, date) => {
  try {
    // TODO: 实现 Google Calendar API 调用
    // 1. 使用 gapi.client.calendar.events.list
    // 2. 过滤该教练的日历
    // 3. 返回指定日期的课程
    
    const response = await fetch('/api/calendar/instructor', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ instructorId, date })
    });
    
    return await response.json();
  } catch (error) {
    console.error('获取课程安排失败:', error);
    throw error;
  }
};

/**
 * 学员预约课程
 * @param {Object} booking - 预约信息
 * @returns {Promise<Object>} 预约结果
 */
export const bookLesson = async (booking) => {
  try {
    // TODO: 创建 Google Calendar 事件
    // 1. 状态设为 "待确认"
    // 2. 发送通知给办公室
    // 3. 返回预约ID
    
    const response = await fetch('/api/calendar/book', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(booking)
    });
    
    return await response.json();
  } catch (error) {
    console.error('预约课程失败:', error);
    throw error;
  }
};

/**
 * 取消课程（周一至周五 3pm 前）
 * @param {string} eventId - 课程ID
 * @returns {Promise<boolean>} 是否成功
 */
export const cancelLesson = async (eventId) => {
  try {
    const now = new Date();
    const day = now.getDay(); // 0=周日, 1-5=周一至周五
    const hour = now.getHours();
    
    // 检查取消时间限制
    if (day === 0 || day === 6 || (day >= 1 && day <= 5 && hour >= 15)) {
      throw new Error('只能在周一至周五下午3点前取消课程');
    }
    
    const response = await fetch('/api/calendar/cancel', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventId })
    });
    
    return await response.json();
  } catch (error) {
    console.error('取消课程失败:', error);
    throw error;
  }
};

/**
 * 同步 Calendar 到 Google Sheets
 * (由 Firebase Functions 定时触发)
 */
export const syncCalendarToSheets = async () => {
  // 这个函数会在 Firebase Functions 中实现
  // 定时任务: 每天晚上 11:59pm 同步当日数据
  console.log('Calendar → Sheets 同步将通过 Cloud Functions 自动执行');
};
